module.exports = __webpack_public_path__ + "media/src/images/icons/footer/footer-privacy-292a2fd60473cc94e7cfe3c6d33eb98f.svg";